var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrifileIconHelpSupportThird(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3332 17.3332C18.5114 17.3332 19.4665 16.3781 19.4665 15.1999V13.0665C19.4665 11.8883 18.5114 10.9332 17.3332 10.9332C16.7441 10.9332 16.2665 11.4108 16.2665 11.9999V16.2665C16.2665 16.8556 16.7441 17.3332 17.3332 17.3332ZM17.3332 17.3332C17.3332 18.5114 16.3781 19.4665 15.1999 19.4665H12.5332M19.4665 14.6665V11.9999C19.4665 7.87614 16.1236 4.5332 11.9999 4.5332C7.87614 4.5332 4.5332 7.87614 4.5332 11.9999V14.6665M6.66654 17.3332C7.25564 17.3332 7.7332 16.8556 7.7332 16.2665V11.9999C7.7332 11.4108 7.25564 10.9332 6.66654 10.9332C5.48833 10.9332 4.5332 11.8883 4.5332 13.0665V15.1999C4.5332 16.3781 5.48833 17.3332 6.66654 17.3332Z",
    stroke: "#333333",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrifileIconHelpSupportThird);
export default __webpack_public_path__ + "static/media/PrifileIconHelpSupportThird.56511fbb2e2a7aee72042ff9ba9d043f.svg";
export { ForwardRef as ReactComponent };